/**
 * WPS PDF - Read, Edit, Fill, Convert, and AI Chat PDF
 *
 * Exposes 8 static resources scoped to `https://ds.cache.wpscdn.com/*` and
 * `https://scholar.google.com/*`. The Scholar grant is the interesting one: WPS
 * injects a content script there, so any script running on Google Scholar — not just
 * WPS's own — can use the same grant to enumerate the extension.
 *
 * Six of the eight declared resources (ai_chat.png and friends) are not actually
 * shipped in the package — the manifest entry is stale. Probing them fails whether or
 * not the extension is installed, so the probes use the two that really exist.
 *
 * Manifest verified against version 1.0.0.58.
 */

import { probeImage } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'kdpelmjpfafjppnhbloffcjpeomlnpah';

export const wpsPdf: ExtensionDefinition = {
  id: ID,
  name: 'WPS PDF - Read, Edit, Fill, Convert, and AI Chat PDF',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 7_000_000,
  requiredOrigin: 'https://scholar.google.com',
  notes:
    'Static resources are scoped to wpscdn.com and scholar.google.com, so any script ' +
    'on Google Scholar can enumerate this extension. Six of the eight declared ' +
    'resources are not shipped at all — the manifest entry is stale.',
  signals: [
    {
      id: 'war-pdf48-icon',
      kind: 'web-accessible-resource',
      description:
        'Load icons/pdf48.png via <img> — exposed to scholar.google.com, where WPS ' +
        'injects its content script.',
      weight: 1,
      run: () => probeImage(ID, 'icons/pdf48.png'),
    },
    {
      id: 'war-pdf16-icon',
      kind: 'web-accessible-resource',
      description: 'Load icons/pdf16.png via <img> to corroborate.',
      weight: 0.5,
      run: () => probeImage(ID, 'icons/pdf16.png'),
    },
  ],
};
